import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-layer-gray",
  "use": "icon-add-layer-gray-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add-layer-gray\"><path d=\"M123.1 98.3c-14.3 0-25.9 11.6-25.9 25.9v526.6l277.5 277.3h526.4c14.3 0 25.9-11.6 25.9-25.9v-778c0-14.3-11.6-25.9-25.9-25.9h-778z m283.2 767.6L159.4 619.2v-0.2h247.8v246.9h-0.9z m456.5-2H469.4V582.7c0-14.3-11.6-25.9-25.9-25.9H161.4V162.5h701.4v701.4z\" p-id=\"52406\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol